import React from 'react';
import Banner from '../components/Widgets/Banner';

const Forbidden = (props) => {
  return <Banner type="urgent" description={props.description}/>
}


export default Forbidden;
